import { Directive, ElementRef, OnInit } from '@angular/core'

@Directive({
   // eslint-disable-next-line @angular-eslint/directive-selector
   selector: '[autoFocus]',
   standalone: true
})
export class AutoFocusDirective implements OnInit {
   private inputElement: HTMLElement

   constructor(private elementRef: ElementRef) {
      this.inputElement = this.elementRef.nativeElement
   }

   ngOnInit(): void {
      this.inputElement.focus()
   }
}